/* eslint-disable @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports */

export const affinity: string = require("./affinity.png");
export const asana: string = require("./asana.png");
export const coursera: string = require("./coursera.svg");
export const curology: string = require("./curology.png");
export const doximity: string = require("./doximity.png");
export const envoy: string = require("./envoy.svg");
export const lattice: string = require("./lattice.png");
export const lyft: string = require("./lyft.png");
export const intercom: string = require("./intercom.svg");
export const slack: string = require("./slack.png");
export const strava: string = require("./strava.svg");
export const turo: string = require("./turo.png");
export const twitter: string = require("./twitter.svg");
export const vimeo: string = require("./vimeo.png");
export const zymergen: string = require("./zymergen.png");
